// 2023医院统计
<template>
  <div class='reportDetails' style='background-color:#fff;' >
    <div class="update-box" v-if="!isShowEmpty&&!isLoading&&reportData.isWeb!=1">
      <div class="update df-between" :style="{'top':topHeight}">
        <div class='left'>每日凌晨2:00更新报告数据</div>
      </div>
    </div>
    <div class="container" v-if="!isShowEmpty&&!isLoading" style='background-color:#eee;' :style='{"padding-top":reportData.isWeb!=1?"30px":"0px"}'>
      <webHeader v-if='reportData.isWeb==1' :isWeb='reportData.isWeb' v-on:handleCatelogue='handleCatelogue' v-on:setWord='setWord'></webHeader>
      <hospitalStatistics class='hospitalStatistics' v-on:sendEchartsImg="sendEchartsImg" :reportData='reportData' ></hospitalStatistics>
      <dragIndex :source='$route.query.source' v-if='reportData.isWeb!=1' :isWeb='reportData.isWeb' v-on:handleShare='handleShare' v-on:handleCatelogue='handleCatelogue' v-on:handleDownLoad='handleDownLoad'></dragIndex>
      <v-catalogue ref="catalogue" :catalogueData="catalogueData" :isWeb='reportData.isWeb' safeContainerDomId="hps-scroll"></v-catalogue>
    </div>
    <div class="empty " v-if='isShowEmpty&&!isLoading' style='background-color:#fff;'>
      <img src="../../assets/images/notAuditRecord.png" alt="" >
      <div class='empty-text' style='font-size:18px;color:#333;'>{{this.delText}}</div>
    </div>
    <van-action-sheet v-model="actionSheetLeft" :actions="actions1" cancel-text="取消" close-on-click-action @select="selectActionSheetLeft" />
    <div class="actionSheetRIght-box">
      <van-action-sheet v-model="actionSheetRIght" :actions="actions2" cancel-text="取消" close-on-click-action @select="selectActionSheetRight" />
    </div>
    <!-- <div class="footer df-center" >
      <button class="online-save" @click="onlineSave" >在线发送</button>
      <button class="download-save" @click="setWord" >下载后发送</button>
    </div> -->
  </div>
</template>
<script>
  import Vue from 'vue'
  import hospitalStatistics from './hospitalStatisticsChild2023'
  import dragIndex from './dragIndex.vue'
  import webHeader from './webHeader'
  import store from '@/store/index'
  import vCatalogue from '../../components/catelogue/catalogue.vue'
  import {mapState, mapGetters } from 'vuex'
  import axios from 'axios'
  import { Toast } from 'vant'

  Vue.use(Toast)
  export default {
    props:['containerHeight','topHeight'],
    data() {
      return {
        taskId:'',
        catalogueData:[
          {
            title: '1. 手卫生知识知晓率情况',
            domId: 'hps-1',
            children: [
              {
                title: '1.1 手卫生学习任务完成情况',
                domId: 'hps-1.1'
              },
              {
                title: '1.2 手卫生考试情况',
                domId: 'hps-1.2'
              },
              {
                title: '1.3 手卫生证书获得情况',
                domId: 'hps-1.3'
              },
            ]
          },
          {
            title: '2. 调查科室手卫生依从及正确执行情况',
            domId: 'hps-2',
            children: [
              {
                title: '2.1 调查科室洗手/卫生手消毒依从及正确执行情况',
                domId: 'hps-2.1',
                children: [
                  {
                    title: '2.1.1 本次调查洗手/卫生手消毒时机依从率/正确率',
                    domId: 'hps-2.1.1'
                  },
                  {
                    title: '2.1.2 不同指征洗手/卫生手消毒时机依从率/正确率',
                    domId: 'hps-2.1.2'
                  },
                  {
                    title: '2.1.3 不同岗位人员洗手/卫生手消毒时机依从率/正确率',
                    domId: 'hps-2.1.3'
                  },
                  {
                    title: '2.1.4 不同岗位人员指征依从率/正确率',
                    domId: 'hps-2.1.4'
                  },
                  {
                    title: '2.1.5 不同实施方式依从率与正确率',
                    domId: 'hps-2.1.5'
                  },
                  {
                    title: '2.1.6 单元洗手/卫生手消毒平均依从率/正确率以及管理目标值达标情况',
                    domId: 'hps-2.1.6'
                  }
                ]
              },
              {
                title: '2.2 外科手消毒依从及正确执行情况',
                domId: 'hps-2.2',
                children: [
                  {
                    title: '2.2.1 本次调查外科手消毒依从率/正确率',
                    domId: 'hps-2.2.1'
                  },
                  {
                    title: '2.2.2 不同指征外科手消毒依从率/正确率',
                    domId: 'hps-2.2.2'
                  }
                ]
              }
            ]
          },
          {
            title: '3. 调查科室手卫生用品消耗情况',
            domId: 'hps-3',
            children: [
              {
                title: '3.1 手卫生用品消耗情况',
                domId: 'hps-3.1'
              },
              {
                title: '3.2 手卫生用品抽检情况',
                domId: 'hps-3.2'
              }
            ]
          },
          {
            title: '4. 重点质控指标情况',
            domId: 'hps-4'
          },
          {
            title: '5. 管理提示',
            domId: 'hps-5',
            children: [
              {
                title: '5.1 手卫生依从率与同类医院比较',
                domId: 'hps-5.1'
              },
              {
                title: '5.2 手卫生知识知晓率对依从率的影响',
                domId: 'hps-5.2'
              },
              {
                title: '5.3 手卫生用品消耗量与手卫生依从率的关系',
                domId: 'hps-5.3',
                children: [
                  {
                    title: '5.3.1 综合ICU',
                    domId: 'hps-5.3.1'
                  },
                  {
                    title: '5.3.2 呼吸科(组)',
                    domId: 'hps-5.3.2'
                  },
                  {
                    title: '5.3.3 骨科',
                    domId: 'hps-5.3.3'
                  },
                  {
                    title: '5.3.4 感染病科(组)',
                    domId: 'hps-5.3.4'
                  },
                  {
                    title: '5.3.5 儿科门急诊',
                    domId: 'hps-5.3.5'
                  },
                  {
                    title: '5.3.6 血液透析室',
                    domId: 'hps-5.3.6'
                  }
                ]
              },
              {
                title: '5.4 手卫生依从率对感染率的影响',
                domId: 'hps-5.4'
              },
              {
                title: '5.5 综合ICU三管的感染率与同级别医院的比较',
                domId: 'hps-5.5',
                children: [
                  {
                    title: '5.5.1 综合ICU血管导管相关血流感染发病率',
                    domId: 'hps-5.5.1'
                  },
                  {
                    title: '5.5.2 综合ICU呼吸机相关肺炎发病率',
                    domId: 'hps-5.5.2'
                  },
                  {
                    title: '5.5.3 综合ICU导尿管相关泌尿系感染发病率',
                    domId: 'hps-5.5.3'
                  }
                ]
              },
            ]
          },
          {
            title: '附1 手卫生知识学习任务清单',
            domId: 'hps-fu1'
          },
          {
            title: '附2 考试试卷题目清单',
            domId: 'hps-fu2'
          },
        ],
        actions1: [
          { name: '通过微信/QQ发送' }
        ],
        actions2: [
          {
            name: '脱敏下载分享',
            subname: '(为保障数据隐私安全，建议您脱敏分享)',
          },
          { name: '下载分享' },
        ],
        actionSheetLeft: false,
        actionSheetRIght: false,
        isShowEmpty: true, // 所有数据为空
        isLoading:true, //加载中
        delText: '无数据',
        formData: {},
        echartsChildData: {}, // 所有子组件获取的echarts图存在这里
        reportData: {
          batch:'',
          isWeb:0,
          isDesensitization: '',
          fileId: '',
          baseUrl: '',
          echartsThreeData:[],
        }
      }
    },
    computed: {
      ...mapGetters([
      ]),
      ...mapState({
        _userInfo: (state) => state.InvestorInfo,
        baseUrl: (state) => state._base
      })
    },
    created() {
      this.taskId = this.$route.query.taskId ? this.$route.query.taskId : localStorage.getItem('taskId')
      this.reportData.batch = this.$route.query.batch ? this.$route.query.batch : localStorage.getItem('batch')
      this.reportData.baseUrl = this.baseUrl
      this.reportData.handComplianceTarget = localStorage.getItem('handComplianceTarget')?localStorage.getItem('handComplianceTarget'):this.$route.query.handComplianceTarget
      this.reportData.handCorrectionTarget = localStorage.getItem('handCorrectionTarget')?localStorage.getItem('handCorrectionTarget'):this.$route.query.handCorrectionTarget
      console.log(this.reportData.handComplianceTarget,'444');

      this.reportData.isWeb = this.$route.query.isWeb
      if(this.reportData.isWeb == 1){
        this.actions2[0].name = '脱敏下载'
        this.actions2[0].subname = '(为保障数据隐私安全，建议您脱敏下载)'
        this.actions2[1].name = '下载'
      }
      this.formData = new FormData()
      this.initHospitalStatisticsBody()
      console.log(window.location.href,'当前url地址');
    },
    mounted() {
      document.title = '报告详情'
    },
    components: {
      hospitalStatistics: hospitalStatistics,
      dragIndex:dragIndex,
      vCatalogue,
      webHeader
    },
    methods: {
      // 分享
      handleShare(){
        this.onlineSave()
      },
      // 下载
      handleDownLoad(){
        this.setWord()
      },
      // 目录
      handleCatelogue(){
        this.$refs['catalogue'].openCatalogue()
      },
      initHospitalStatisticsBody() {
        store.commit('showLoading')
        Promise.all([
          this.$http
            .queryHandHospitalStatisticsReport001_2023({ // 分享出去取this.$route.query.comId
              comId: this.$route.query.comId?this.$route.query.comId:this._userInfo.data.comId,
              taskId: this.taskId
            })
            .then((res) => {
              this.reportData.contentObj = res.data[0][0] || []
              this.reportData.tableOneData = res.data[1] || []
              this.reportData.tableTwoData = res.data[2] || []
              this.reportData.tableThreeData = res.data[3] || []
              this.reportData.tableFourData = res.data[4] || []
              this.reportData.echartsOneData =  res.data[4] || []
              this.reportData.tableFiveData = res.data[5] || []
              this.reportData.tableSixData = res.data[6] || []
              this.reportData.tableSevenData = res.data[7] || []
            }).catch((err) => {
              this.isShowEmpty = true
            }),
          this.$http
            .queryHandHospitalStatisticsReport002_2023({
              comId: this.$route.query.comId?this.$route.query.comId:this._userInfo.data.comId,
              taskId: this.taskId
            })
            .then((res) => {
              if (res.code == 0) {
                this.reportData.tableEightData = res.data[0] || []
                this.reportData.tableNineData = res.data[1] || []
                this.reportData.echartsTwoData = res.data[1] || []
                if(res.data[2].length>0){
                  res.data[2].forEach((v,i)=>{
                    if(v.NATURE_NAME == '小计'){
                      this.reportData.echartsThreeData.push(v)
                    }
                  })
                }
                this.reportData.tableTenData = this.handleMergeRow(res.data[2] || [])
                this.reportData.tableElevenData = this.handleMergeRow2(res.data[3] || [])
                this.reportData.echartsFourData = res.data[4] || []
                this.reportData.tableTwelveData = res.data[5] || []
                this.reportData.echartsFiveData = res.data[5] || []
                this.reportData.tableThirteenData = res.data[6] || []
                this.reportData.tableFourteenData = res.data[7] || []
              }
            }).catch((err) => {
              this.isShowEmpty = true
            }),
          this.$http
          .queryHandHospitalStatisticsReport003_2023({
            comId: this.$route.query.comId?this.$route.query.comId:this._userInfo.data.comId,
            taskId: this.taskId
          })
          .then((res) => {
            this.reportData.tableSeventeenData = res.data[0] || []
            this.reportData.tableEighteenData = res.data[1] || []
            this.reportData.tableNineteenData = res.data[2] || []
            this.reportData.tableNineteen_4Data = res.data[3] || []
          }).catch((err) => {
              this.isShowEmpty = true
            }),
          this.$http
          .queryHandHospitalStatisticsReport004_2023({
            comId: this.$route.query.comId?this.$route.query.comId:this._userInfo.data.comId,
            taskId: this.taskId
          })
          .then((res) => {
            this.reportData.tableTwentyData = this.handleMergeRow3(res.data[0] || [])
            this.reportData.CONTENT26= res.data[1][0].CONTENT26
          }).catch((err) => {
              this.isShowEmpty = true
            }),
          this.$http
          .queryHandHospitalStatisticsReport005_1_2023({
            comId: this.$route.query.comId?this.$route.query.comId:this._userInfo.data.comId,
            taskId: this.taskId
          })
          .then((res) => {
            this.reportData.CONTENT510 = res.data[0][0].CONTENT510
            this.reportData.CONTENT511 = res.data[0][0].CONTENT511
            this.reportData.CONTENT512 = res.data[0][0].CONTENT512
            this.reportData.CONTENT513 = res.data[0][0].CONTENT513
            this.reportData.CONTENT514 = res.data[0][0].CONTENT514
            this.reportData.tablep511Data = res.data[0]
          }).catch((err) => {
              this.isShowEmpty = true
            }),
          this.$http
          .queryHandHospitalStatisticsReport005_2_2023({
            comId: this.$route.query.comId?this.$route.query.comId:this._userInfo.data.comId,
            taskId: this.taskId
          })
          .then((res) => {
            this.reportData.CONTENT520 = res.data[0][0].CONTENT520
            this.reportData.CONTENT521 = res.data[0][0].CONTENT521
            this.reportData.CONTENT522 = res.data[0][0].CONTENT522
            this.reportData.CONTENT523 = res.data[0][0].CONTENT523
            this.reportData.CONTENT524 = res.data[0][0].CONTENT524
            this.reportData.CONTENT525 = res.data[0][0].CONTENT525
            this.reportData.CONTENT526 = res.data[0][0].CONTENT526
            this.reportData.tablep521Data = res.data[0]
            
          }).catch((err) => {
              this.isShowEmpty = true
            }),
          this.$http
          .queryHandHospitalStatisticsReport005_3_2023({
            comId: this.$route.query.comId?this.$route.query.comId:this._userInfo.data.comId,
            taskId: this.taskId
          })
          .then((res) => {
            this.reportData.CONTENT5310 = res.data[0][0].CONTENT5310
            this.reportData.CONTENT5311 = res.data[0][0].CONTENT5311
            this.reportData.CONTENT5312 = res.data[0][0].CONTENT5312
            this.reportData.CONTENT5313 = res.data[0][0].CONTENT5313
            this.reportData.CONTENT5314 = res.data[0][0].CONTENT5314
            this.reportData.CONTENT5315 = res.data[0][0].CONTENT5315
            this.reportData.CONTENT5316 = res.data[0][0].CONTENT5316
            this.reportData.CONTENT5317 = res.data[0][0].CONTENT5317
            this.reportData.CONTENT5318 = res.data[0][0].CONTENT5318
            this.reportData.tablep5311Data = res.data[0]

            this.reportData.CONTENT5320 = res.data[1][0].CONTENT5320
            this.reportData.CONTENT5321 = res.data[1][0].CONTENT5321
            this.reportData.CONTENT5322 = res.data[1][0].CONTENT5322
            this.reportData.CONTENT5323 = res.data[1][0].CONTENT5323
            this.reportData.CONTENT5324 = res.data[1][0].CONTENT5324
            this.reportData.CONTENT5325 = res.data[1][0].CONTENT5325
            this.reportData.CONTENT5326 = res.data[1][0].CONTENT5326
            this.reportData.CONTENT5327 = res.data[1][0].CONTENT5327
            this.reportData.CONTENT5328 = res.data[1][0].CONTENT5328
            this.reportData.tablep5321Data = res.data[1]

            this.reportData.CONTENT5330 = res.data[2][0].CONTENT5330
            this.reportData.CONTENT5331 = res.data[2][0].CONTENT5331
            this.reportData.CONTENT5332 = res.data[2][0].CONTENT5332
            this.reportData.CONTENT5333 = res.data[2][0].CONTENT5333
            this.reportData.CONTENT5334 = res.data[2][0].CONTENT5334
            this.reportData.CONTENT5335 = res.data[2][0].CONTENT5335
            this.reportData.CONTENT5336 = res.data[2][0].CONTENT5336
            this.reportData.CONTENT5337 = res.data[2][0].CONTENT5337
            this.reportData.CONTENT5338 = res.data[2][0].CONTENT5338
            this.reportData.tablep5331Data = res.data[2]

            this.reportData.CONTENT5340 = res.data[3][0].CONTENT5340
            this.reportData.CONTENT5341 = res.data[3][0].CONTENT5341
            this.reportData.CONTENT5342 = res.data[3][0].CONTENT5342
            this.reportData.CONTENT5343 = res.data[3][0].CONTENT5343
            this.reportData.CONTENT5344 = res.data[3][0].CONTENT5344
            this.reportData.CONTENT5345 = res.data[3][0].CONTENT5345
            this.reportData.CONTENT5346 = res.data[3][0].CONTENT5346
            this.reportData.CONTENT5347 = res.data[3][0].CONTENT5347
            this.reportData.CONTENT5348 = res.data[3][0].CONTENT5348
            this.reportData.tablep5341Data = res.data[3]

            this.reportData.CONTENT5350 = res.data[4][0].CONTENT5350
            this.reportData.CONTENT5351 = res.data[4][0].CONTENT5351
            this.reportData.CONTENT5352 = res.data[4][0].CONTENT5352
            this.reportData.CONTENT5353 = res.data[4][0].CONTENT5353
            this.reportData.CONTENT5354 = res.data[4][0].CONTENT5354
            this.reportData.CONTENT5355 = res.data[4][0].CONTENT5355
            this.reportData.CONTENT5356 = res.data[4][0].CONTENT5356
            this.reportData.CONTENT5357 = res.data[4][0].CONTENT5357
            this.reportData.CONTENT5358 = res.data[4][0].CONTENT5358
            this.reportData.tablep5351Data = res.data[4]

            this.reportData.CONTENT5360 = res.data[5][0].CONTENT5360
            this.reportData.CONTENT5361 = res.data[5][0].CONTENT5361
            this.reportData.CONTENT5362 = res.data[5][0].CONTENT5362
            this.reportData.CONTENT5363 = res.data[5][0].CONTENT5363
            this.reportData.CONTENT5364 = res.data[5][0].CONTENT5364
            this.reportData.CONTENT5365 = res.data[5][0].CONTENT5365
            this.reportData.CONTENT5366 = res.data[5][0].CONTENT5366
            this.reportData.CONTENT5367 = res.data[5][0].CONTENT5367
            this.reportData.CONTENT5368 = res.data[5][0].CONTENT5368
            this.reportData.tablep5361Data = res.data[5]
            
          }).catch((err) => {
              this.isShowEmpty = true
            }),
          this.$http
          .queryHandHospitalStatisticsReport005_4_2023({
            comId: this.$route.query.comId?this.$route.query.comId:this._userInfo.data.comId,
            taskId: this.taskId
          })
          .then((res) => {
            this.reportData.CONTENT540 = res.data[0][0].CONTENT540
            this.reportData.CONTENT541 = res.data[0][0].CONTENT541
            this.reportData.CONTENT542 = res.data[0][0].CONTENT542
            this.reportData.CONTENT543 = res.data[0][0].CONTENT543
            this.reportData.CONTENT544 = res.data[0][0].CONTENT544
            this.reportData.CONTENT545 = res.data[0][0].CONTENT545
            this.reportData.CONTENT546 = res.data[0][0].CONTENT546
            this.reportData.CONTENT547 = res.data[0][0].CONTENT547
            this.reportData.tablep541Data = res.data[0]
            
          }).catch((err) => {
              this.isShowEmpty = true
            }),
          this.$http
          .queryHandHospitalStatisticsReport005_5_2023({
            comId: this.$route.query.comId?this.$route.query.comId:this._userInfo.data.comId,
            taskId: this.taskId
          })
          .then((res) => {
            this.reportData.CONTENT5510 = res.data[0][0].CONTENT5510
            this.reportData.CONTENT5511 = res.data[0][0].CONTENT5511
            this.reportData.CONTENT5512 = res.data[0][0].CONTENT5512
            this.reportData.CONTENT5513 = res.data[0][0].CONTENT5513
            this.reportData.CONTENT5514 = res.data[0][0].CONTENT5514
            this.reportData.tablep5511Data = res.data[0]

            this.reportData.CONTENT5520 = res.data[1][0].CONTENT5520
            this.reportData.CONTENT5521 = res.data[1][0].CONTENT5521
            this.reportData.CONTENT5522 = res.data[1][0].CONTENT5522
            this.reportData.CONTENT5523 = res.data[1][0].CONTENT5523
            this.reportData.CONTENT5524 = res.data[1][0].CONTENT5524
            this.reportData.tablep5521Data = res.data[1]

            this.reportData.CONTENT5530 = res.data[2][0].CONTENT5530
            this.reportData.CONTENT5531 = res.data[2][0].CONTENT5531
            this.reportData.CONTENT5532 = res.data[2][0].CONTENT5532
            this.reportData.CONTENT5533 = res.data[2][0].CONTENT5533
            this.reportData.CONTENT5534 = res.data[2][0].CONTENT5534
            this.reportData.tablep5531Data = res.data[2]
            
          }).catch((err) => {
              this.isShowEmpty = true
            }),
          this.$http
            .queryHandHospitalStatisticsReport006_2023({
              comId: this.$route.query.comId?this.$route.query.comId:this._userInfo.data.comId,
              taskId: this.taskId
            })
            .then((res) => {
              if (res.code == 0) {
                this.reportData.tableFifteenData = this.handleMergeRowTwo(res.data[0] || [])
                this.reportData.tableSixteenData = res.data[1] || []
              }
            }).catch((err) => {
              this.isShowEmpty = true
            }),
            this.$http
            .queryHandHospitalStatisticsReport007_2023({
              comId: this.$route.query.comId?this.$route.query.comId:this._userInfo.data.comId,
              taskId: this.taskId
            })
            .then((res) => {
              if (res.code == 0) {
                this.reportData.CONTENT27= res.data[0][0].CONTENT
                this.reportData.tableTwentyOneData = res.data[1] || []
                this.reportData.tableTwentyTwoData = res.data[2] || []
                this.reportData.echartsTwo2Data = res.data[2] || []
                if(!this.reportData.CONTENT27){
                  this.catalogueData[1].children.splice(1,1) // 去掉外科手消毒目录
                }
              }
            }).catch((err) => {
              this.isShowEmpty = true
            }),
            this.$http
            .queryHandHospitalStatisticsReport008_2023({
              comId: this.$route.query.comId?this.$route.query.comId:this._userInfo.data.comId,
              taskId: this.taskId
            })
            .then((res) => {
              if (res.code == 0) {
                this.reportData.contentObj008 = res.data[0][0] || {}
                if(this.reportData.contentObj008.HAS_DATA == '0'){
                  this.catalogueData[2].children.splice(1,1) // 去掉手卫生用品抽检情况
                }
                this.reportData.tableTwentyThreeData = res.data[1] || []
              }
            }).catch((err) => {
              this.isShowEmpty = true
            }),
        ])
          .then((res) => {
            this.reportData.handStr = this.handleYclNumberAndZqlNumber(this.reportData.tableThirteenData,this.reportData.handComplianceTarget,this.reportData.handCorrectionTarget)
            this.isLoading = false
            //CONTENT4为手卫生学习任务参与人数  CONTENT9为手卫生考试参与人数  CONTENT16为手卫生时机
            if(!this.reportData.contentObj.CONTENT4&&!this.reportData.contentObj.CONTENT9&&!this.reportData.contentObj.CONTENT16){
              this.isShowEmpty = true
            }else{
              this.isShowEmpty = false
            }
            store.commit('hideLoading')
          })
          .catch((err) => {
            this.isShowEmpty = true
            console.log(err)
          })
      },
      handleYclNumberAndZqlNumber (tableData,handComplianceTarget,handCorrectionTarget) {
        let yclYetNumber = 0  //依从率达标单元数
        let yclNotNumber = 0  //依从率不达标单元数
        let zqlYetNumber = 0  //正确率达标单元数
        let zqlNotNumber = 0  //正确率不达标单元数
        if(tableData.length>0){
          tableData.forEach((v,i)=>{
            if(v.YCL!=null&&v.YCL > parseInt(handComplianceTarget) || v.YCL == parseInt(handComplianceTarget)){
              yclYetNumber++
            }
            if(v.ZQL!=null&&v.ZQL > parseInt(handCorrectionTarget) || v.ZQL == parseInt(handCorrectionTarget)){
              zqlYetNumber++
            }
            if(v.YCL!=null&&v.YCL < parseInt(handComplianceTarget)){
              yclNotNumber++
            }
            if(v.ZQL!=null&&v.ZQL < parseInt(handCorrectionTarget)){
              zqlNotNumber++
            }
          })
        }
        return '与目标值对比：'+ yclYetNumber +'个单元依从率达标，'+ yclNotNumber +'个单元依从率不达标，'+ zqlYetNumber +'个单元正确率达标，'+ zqlNotNumber +'个单元正确率不达标。'
      },
      selectActionSheetLeft(name, index) {
        if (index == 1) {
          // 在app内发送到单元
          this.isShowRole = true
        } else {
          // 通过微信发送
          let url = `${this.baseUrl}/handMonitorReported/#/hospitalStatistics2023?source=1&taskId=${this.taskId}&comId=${this._userInfo.data.comId}&handComplianceTarget=${this.reportData.handComplianceTarget}&handCorrectionTarget=${this.reportData.handCorrectionTarget}&batch=${this.reportData.batch}`
          // let url = `${this.baseUrl}/#/hospitalStatistics?source=1&comId=${this._userInfo.data.comId}`
          let title = this.reportData.contentObj.CONTENT24
          let content = '仅限院内分享，请注意数据安全'
          try {
            uni.postMessage({
              data: {
                action: 'showShareView',
                data: {
                  shareUrl: url,
                  shareTitle: title,
                  shareContent: content,
                }
              }
            });
            window.webkit.messageHandlers.showShareView.postMessage({
              shareUrl: url,
              shareTitle: title,
              shareContent: content,
            })
          } catch (err) {
            window.gk.showShareView(url, title, content)
          }
        }
      },
      handleWindowGk() {
        try {
          uni.postMessage({
            data: {
              action: 'downLoad',
              data: {
                url:
                  this.reportData.baseUrl +
                  '/incontrol-fileserver/file/download/' +
                  this.reportData.fileId +
                  '.docx',
                reportId: -1,
                rptTitleAlias: this.reportData.contentObj.CONTENT24,
                isDesensitization: this.reportData.isDesensitization,
              }
            }
          });
          window.webkit.messageHandlers.downLoad.postMessage({
            url:
              this.reportData.baseUrl +
              '/incontrol-fileserver/file/download/' +
              this.reportData.fileId +
              '.docx',
            reportId: -1,
            rptTitleAlias: this.reportData.contentObj.CONTENT24,
            isDesensitization: this.reportData.isDesensitization,
          })
        } catch (err) {
          window.gk.downLoad(
            this.reportData.baseUrl +
              '/incontrol-fileserver/file/download/' +
              this.reportData.fileId,
            -1,
            this.reportData.isDesensitization == 0
              ? this.reportData.contentObj.CONTENT24 + '(脱敏)'
              : this.reportData.contentObj.CONTENT24
          )
        }
      },
      selectActionSheetRight(name, index) {
        if(this.reportData.isWeb !=1){
          let userData = this._userInfo.data
          this.utils.cnzzStat('H5-全国手卫生监测专项报告-医疗机构','下载报告(Um_Event_DownloadReport)',`${userData.userId}-${userData.postName}-${userData.comName}-${userData.isSign == '1' ? '已签约': '未签约'}-${userData.comProvinceName}`)
        }
        if (index == 0) {
          // 脱敏处理
          this.reportData.isDesensitization = '0'
        } else {
          this.reportData.isDesensitization = '1'
        }
        this.$nextTick(() => {
          // this.reportData.contentObj.CONTENT25 = this.reportData.contentObj.CONTENT25.replace(/\&nbsp;/g,'').replace(/<br\/>/g,'\n    ')
          this.formData.append('reportData', JSON.stringify(this.reportData))
          this.formData.append('files1', this.echartsChildData.echartsUrl1)
          this.formData.append('files2', this.echartsChildData.echartsUrl2)
          this.formData.append('files2_6', this.echartsChildData.echartsUrl2_6)
          this.formData.append('files3', this.echartsChildData.echartsUrl3)
          this.formData.append('files4', this.echartsChildData.echartsUrl4)
          this.formData.append('files5', this.echartsChildData.echartsUrl5)
          this.renderReport(this.formData)
        })
      },
      sendEchartsImg(val) {
        this.echartsChildData = val
      },
      onlineSave() {
        if (this.$route.query.comId || this._userInfo.data.comId) {
          this.actionSheetLeft = true
        } else {
          Toast('您已退出该医院')
        }
      },
      setWord() {
        if (this.$route.query.comId || this._userInfo.data.comId) {
          this.actionSheetRIght = true
        } else {
          Toast('您已退出该医院')
        }
      },
      // 上传文件
      handleUploadFile(data) {
        let formData = new FormData()
        formData.append('file', data, this.reportData.contentObj.CONTENT24 + '.docx')
        this.$http.uploadFile(formData) .then((res) => { 
          if (res.code == 0) {
            this.reportData.fileId = res.data.fileId
            if (this.reportData.fileId) {
              this.handleWindowGk()
            }
          }
        })
      },
      // pc端下载文件
      downloadOrPc(blob) {
        const fileName = this.reportData.contentObj.CONTENT24+'.docx'
        if ('download' in document.createElement('a')) {
          // 非IE下载
          console.log('web下载')
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      },
      renderReport(data) {
        this.formData = new FormData() // 不加这个下载一次后再次下载会报错
        axios({
          method: 'post',
          url:'/node-report/handHospitalStatistics2023/getHandHospitalStatisticsReport_2023', // 线上
          // url:'/handHospitalStatistics2023/getHandHospitalStatisticsReport_2023', // 本地调试
          data: data,
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          responseType: 'blob'
        }).then((res)=>{
          const content = res.data
          const blob = new Blob([content])
          if(this.reportData.isWeb == 1){
            console.log('pc端');
            this.downloadOrPc(blob)
          }else{
            console.log('移动端');
            this.handleUploadFile(blob)
          }
        })
      },
      handleMergeRow(tableData) {
        let tempArr = []
        let mergeData = []
        for (var i = 0; i < tableData.length; i++) {
          // 将数组每项中含有相同属性值的项合并
          if (tempArr.indexOf(tableData[i].WORK_NAME) === -1) {
            mergeData.push({
              WORK_NAME: tableData[i].WORK_NAME,
              dataInfo: [tableData[i]],
            })
            tempArr.push(tableData[i].WORK_NAME)
          } else {
            for (var j = 0; j < mergeData.length; j++) {
              if (mergeData[j].WORK_NAME == tableData[i].WORK_NAME) {
                mergeData[j].dataInfo.push(tableData[i])
                break
              }
            }
          }
        }
        return mergeData
      },
      handleMergeRow2(tableData) {
        let tempArr = []
        let mergeData = []
        for (var i = 0; i < tableData.length; i++) {
          // 将数组每项中含有相同属性值的项合并
          if (tempArr.indexOf(tableData[i].INDICATION_NAME) === -1) {
            mergeData.push({
              INDICATION_NAME: tableData[i].INDICATION_NAME,
              dataInfo: [tableData[i]],
            })
            tempArr.push(tableData[i].INDICATION_NAME)
          } else {
            for (var j = 0; j < mergeData.length; j++) {
              if (mergeData[j].INDICATION_NAME == tableData[i].INDICATION_NAME) {
                mergeData[j].dataInfo.push(tableData[i])
                break
              }
            }
          }
        }
        return mergeData
      },
      handleMergeRow3(tableData) {
        let tempArr = []
        let mergeData = []
        for (var i = 0; i < tableData.length; i++) {
          // 将数组每项中含有相同属性值的项合并
          if (tempArr.indexOf(tableData[i].INDEX_NAME) === -1) {
            mergeData.push({
              INDEX_NAME: tableData[i].INDEX_NAME,
              dataInfo: [tableData[i]],
            })
            tempArr.push(tableData[i].INDEX_NAME)
          } else {
            for (var j = 0; j < mergeData.length; j++) {
              if (mergeData[j].INDEX_NAME == tableData[i].INDEX_NAME) {
                mergeData[j].dataInfo.push(tableData[i])
                break
              }
            }
          }
        }
        return mergeData
      },
      handleMergeRowTwo(tableData) {
        let tempArr = []
        let mergeData = []
        for (var i = 0; i < tableData.length; i++) {
          // 将数组每项中含有相同属性值的项合并
          if (tempArr.indexOf(tableData[i].TASK_ORDER) === -1) {
            mergeData.push({
              TASK_ORDER: tableData[i].TASK_ORDER,
              TASK_NAME: tableData[i].TASK_NAME,
              dataInfo: [tableData[i]],
            })
            tempArr.push(tableData[i].TASK_ORDER)
          } else {
            for (var j = 0; j < mergeData.length; j++) {
              if (mergeData[j].TASK_ORDER == tableData[i].TASK_ORDER) {
                mergeData[j].dataInfo.push(tableData[i])
                break
              }
            }
          }
        }
        return mergeData
      },
    }
  }
</script>
<style lang='scss' scoped>
  @import './public.scss';
  .container{
    display: flex;
    flex-direction: column;
    height: 100vh;
    .hospitalStatistics{
      flex: 1;
      overflow-y: scroll;
      overflow-x: hidden;
    }
  }
</style>
